import React from 'react';
import BeaconBasicUpgradeModal from 'src/components/AddModals/BeaconBasicUpgradeModal';
import RulesUpdateModal from 'src/components/AddModals/RulesUpdateModal';

// Collection of all modals in the application

const AppModals = () => {
  return (
    <>
      <BeaconBasicUpgradeModal />
      <RulesUpdateModal />
    </>
  );
};

export default AppModals;
